import { FlexRow } from '@/components/ui/flex';
import { TabsTrigger } from '@/components/ui/tabs';
import { Text } from '@/components/ui/text';
import { type FC } from 'react';

interface TabTriggerProps {
  value: string;
  label: string;
  count: number;
  isSelected: boolean;
}

export const CustomTabTrigger: FC<TabTriggerProps> = ({
  value,
  label,
  count,
  isSelected,
}) => {
  return (
    <TabsTrigger variant="underline" value={value}>
      <FlexRow className="items-center gap-2 justify-center w-full px-4">
        <Text className="text-base font-medium capitalize">{label}</Text>
        <span
          className={`inline-flex items-center justify-center w-fit px-2 h-7 min-w-7 text-xs font-medium rounded-full ${
            isSelected
              ? 'bg-black text-white'
              : 'bg-neutral-200 text-neutral-600'
          }`}
        >
          {count}
        </span>
      </FlexRow>
    </TabsTrigger>
  );
};
